import AsyncSelect from "@/components/AsyncSelect";
import appConfiguration from "@/components/cfg/AppCfg";
import { useCreateDataTableOptions } from "@/components/data-table/hooks/useCreateDataTableOptions";
import { useDynamicQueryParams } from "@/hooks/useDynamicQueryParams";
import { FilterType } from "@/lib/filters";
import { noop } from "@/lib/noop";
import { EmailTypeService } from "@/services/emailType";
import { ReadEmailType } from "@/types/emailType";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

interface EmailTypeSelectProps {
  value?: string;
  onChange: (emailTypeId: string | undefined) => void;
}

export const EmailTypeSelect = ({ value, onChange }: EmailTypeSelectProps) => {
  const { t } = useTranslation();
  const name = "emailRecipientsTypeSelect";
  const options = useCreateDataTableOptions<ReadEmailType>(name);
  const queryKey = useDynamicQueryParams<ReadEmailType>(name, options);

  const onFilter = useCallback(
    (filterValue: string) => {
      options.setFilterValue("name", {
        value: filterValue,
        filter: FilterType.IncludesString,
      });
    },
    [options],
  );

  return (
    <AsyncSelect
      data-testid="email-recipients-type-select"
      name="emailTypeId"
      onBlur={noop}
      queryKey={queryKey}
      queryFn={() =>
        EmailTypeService.getTypes({
          limit: appConfiguration.selectComponentsPaginationLimit,
          filters: options.filters,
        })
      }
      placeholder={t("emailRecipients.selectType.placeholder")}
      loadingLabel={t("emailRecipients.selectType.loading")}
      noResultsLabel={t("emailRecipients.selectType.empty")}
      searchLabel={t("navigation.search")}
      className="min-w-[320px]"
      value={value}
      onChange={(nextValue) =>
        onChange(nextValue ? String(nextValue) : undefined)
      }
      onFilter={onFilter}
      enabled
    />
  );
};
